import {Component, Input, Output, OnInit, EventEmitter} from "@angular/core";


export class Alert implements OnInit {
    
    public type: string;
    
    public skippable: boolean = false;
    
    public displayTime: number = undefined;
    
    public close: EventEmitter<any> = new EventEmitter();

    private timeout: any;

    ngOnInit(): any {
        if (this.displayTime !== undefined) {
            this.timeout = setTimeout(() => this.skippAlert(), this.displayTime);
        }
    }

    private skippAlert(): void {
        this.skippable = false;
        clearTimeout(this.timeout);
        this.close.emit(undefined);
    }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "a2-alert",
    templateUrl: "src/bootstrap/alert/alert.component.html"
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'type': [{ type: Input },],
'skippable': [{ type: Input },],
'displayTime': [{ type: Input },],
'close': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
